import React, { useState } from 'react';
import { ReactComponent as HelpIcon } from 'assets/icons/help-icon.svg';
import { ReactComponent as CustomerServiceIcon } from 'assets/icons/customer-service-icon.svg';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import ContactSupportModal from 'components/modals/contact-support-modal';
import useDashboardContext from 'contexts/dashboard.context';

const SupportPage = () => {
  const navigate = useNavigate();
  const [showContactModal, setShowContactModal] = useState(false);
  const { activeCompany } = useDashboardContext();

  const SUPPORT_MODES = [
    {
      title: 'Frequently Asked Questions',
      description:
        'Get solutions faster by browsing through detailed answers of frequently asked questions.',
      icon: <HelpIcon />,
      onClick: () => navigate(`/${ROUTE_KEYS.FAQ}`),
      show: true
    },
    {
      title: 'Speak to your business manager',
      description:
        "Can't find the answers  from FAQs? You can also contact your business manager via WhatsApp or email.",
      icon: <CustomerServiceIcon />,
      onClick: () => setShowContactModal(true),
      show: Boolean(activeCompany.fc_business_cs_reps.length)
    }
  ];

  return (
    <div className='flex flex-col gap-8'>
      <article>
        <h3 className='text-2xl font-semibold'>Support</h3>
        <p className='text-sm text-[#6F7376]'>Here to support you every step of the way</p>
      </article>

      <div className='grid grid-cols-[repeat(auto-fill,minmax(340px,1fr))] gap-5'>
        {SUPPORT_MODES.filter((m) => m.show).map((mode, index) => (
          <div
            key={index}
            onClick={mode.onClick}
            className='flex flex-col gap-4 p-5 rounded-md border border-[#EFF0F0] cursor-pointer'>
            <span className='w-[50px] h-[50px] flex items-center justify-center rounded-full bg-[#F4F1F1]'>
              {mode.icon}
            </span>
            <article className='flex flex-col gap-[6px]'>
              <p className='font-medium'>{mode.title}</p>
              <p className='text-sm text-[#6F7376]'>{mode.description}</p>
            </article>
          </div>
        ))}
      </div>
      <ContactSupportModal open={showContactModal} onClose={() => setShowContactModal(false)} />
    </div>
  );
};

export default SupportPage;
